module.exports = __webpack_public_path__ + "img/29.72f22980.jpg";